import * as React from 'react';
import {TextField, css, view} from '@sail/ui';

export const Type = () => (
  <view.div
    uses={[
      css({
        '& > *': {
          padding: css.value('8px 0'),
        },
      }),
    ]}
  >
    <TextField label="Text" type="text" />
    <TextField label="Password" type="password" />
    <TextField label="Search" type="search" />
    <TextField label="Number" type="number" />
  </view.div>
);
